import { writable } from 'svelte/store';

export const elapsedTime = writable(0);
export const currentTime = writable(0);
export const currentStep = writable({});
export const completedSteps = writable([]);

export function generateSteps(numRounds, roundTime, breakTime) {
  return Array(numRounds + (numRounds - 1)).fill('step').map((v, i) => {
    const prefix = i % 2 === 0 ? 'round' : 'break';
    const duration = i % 2 === 0 ? roundTime : breakTime;
    return {
      id: i, type: prefix, step: `${prefix}${i}`, duration,
    };
  });
}

export class Timer {
  constructor(numRounds, roundTime, breakTime) {
    this.intervalId = null;
    this.elapsedId = null;
    this.isRunning = false;
    this.onRound = () => null;
    this.onBreak = () => null;
    this.onComplete = () => null;
    this.steps = generateSteps(numRounds, roundTime, breakTime);
  }

  setAnnouncer(onRound, onBreak, onComplete) {
    this.onRound = onRound;
    this.onBreak = onBreak;
    this.onComplete = onComplete;
  }

  start() {
    clearInterval(this.intervalId);
    clearInterval(this.elapsedId);

    this.isRunning = true;
    this.runTimer(this.steps);
    this.startCountdown();
  }

  startCountdown() {
    this.elapsedId = setInterval(() => {
      elapsedTime.update((n) => {
        const next = n + 1;
        if (next >= 0) {
          return next;
        }
        return n;
      });
      if (!this.isRunning) {
        this.stopCountdown();
      }
    }, 1000);
  }

  stopCountdown() {
    clearInterval(this.elapsedId);
    this.elapsedId = null;
  }

  pause() {
    clearInterval(this.intervalId);
    clearInterval(this.elapsedId);
    this.isRunning = false;
  }

  continue() {
    this.isRunning = true;
  }

  stopClock() {
    this.isRunning = false;
    clearInterval(this.intervalId);
    this.intervalId = null;
  }

  reset() {
    this.stopClock();
    currentTime.set(0);
    elapsedTime.set(0);
    completedSteps.set([]);
    currentStep.set({});
    console.log('Resetting: ', this);
  }

  async runTimer(timerSteps) {
    await timerSteps.reduce(async (prevStep, step) => {
      await prevStep;
      console.log('Run step: ', step);
      await this.runStep(step);
      if (!this.isRunning) {
        throw new Error('PausedError');
      }
      completedSteps.update((prev) => [...prev, step]);
      return Promise.resolve();
    }, Promise.resolve());

    if (this.isRunning) {
      this.stopClock();
      console.log('Complete!', this);
      currentStep.set({});
      this.onComplete();
    }
  }

  runStep(step) {
    currentTime.set(0);
    if (step.type === 'round') {
      this.onRound();
    } else {
      this.onBreak();
    }
    currentStep.set(step);

    clearInterval(this.intervalId);
    this.intervalId = setInterval(() => {
      currentTime.update((n) => n + 1);
    }, 1000);

    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(step);
      }, step.duration * 1000);
    });
  }
}
